<template>
  <div>
    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default table-default--maxw"
    >
      <template #h__full_name>
        <div class="table-default__left">Full name</div>
      </template>
      <template #count="{ row, index }">{{ index }}</template>
      <template #full_name="{ row }">
        <div class="table-default__left table-default__left--photo">
          <span
            :class="`fflag ff-md fflag-${row.client.citizenship ? row.client.citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.client.citizenship ? row.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <template v-if="row.client.gender">
            <img v-if="row.client.gender.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
            <img v-if="row.client.gender.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          </template>
          <img v-else src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            :to="{ name: 'clients-detail', params: { id: row.client.id } }"
            class="table-default__link-border"
          >
            {{ row.client.full_name }}
          </router-link>
          <span v-if="row.age">({{ row.age }} y.o.)</span>
          <img v-if="row.client.category && row.client.category.code === 'tour_leader'" src="@/assets/img/tour-leader-icon.svg" alt="Leader">
          <img v-if="row.birthday" src="@/assets/img/birthday-icon.svg" alt="Birthday">
        </div>
      </template>
      <template #medical="{ row }">
        <div class="table-default__controls">
          <button
            v-if="row.medical_checkup_copy"
            @click="onDownloadFile(row)"
            type="button"
          >
            <img src="@/assets/img/download-table-blue-icon.svg" alt="">
          </button>
          <button v-else type="button" disabled><img src="@/assets/img/not-check-red-icon.svg" alt=""></button>
        </div>
      </template>
      <template #controls="{ row }">
        <button @click="onShowEditModal(row.id)" type="button">
          <img src="@/assets/img/edit-table-icon.svg" alt="">
        </button>
      </template>
    </v-client-table>
    <modal
      name="edit-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('edit-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Upload medical check-up</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="Medical check-up" required>
              <app-uploader
                v-model="medical_checkup_copy"
                class="custom-uploader--flex"
              />
              <template #error>
                <div v-if="$v.medical_checkup_copy.$dirty && !$v.medical_checkup_copy.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button ref="submit" type="submit" :disabled="$v.$error">Save</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { getClimbingGroupsClientsUploads, patchClimbingGroupClients } from '@/http'
import { required } from 'vuelidate/lib/validators'
import axios from 'axios'

export default {
  name: 'ClimbingGroupsDetailUploads',
  props: {
    groupDetail: {
      type: Object
    }
  },
  data() {
    return {
      table: {
        items: [],
        columns: [
          'count',
          'full_name',
          'medical',
          'controls',
        ],
        options: {
          headings: {
            'count': '#',
            'full_name': 'Full name',
            'medical': 'Medical',
            'controls': '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 300,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      medical_checkup_copy: null,
      client_to_update: null,
    }
  },
  validations: {
    medical_checkup_copy: { required },
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      getClimbingGroupsClientsUploads(Number(this.$route.params.id))
        .then(res => {
          this.table.items = res.data
        })
    },
    onCheckForm() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      patchClimbingGroupClients(this.$route.params.id, this.client_to_update, { medical_checkup_copy: this.medical_checkup_copy.id })
        .then(() => {
          this.fetchItems()
          this.$notify({
            type: 'success',
            title: 'Data saved successfully',
          })
          this.$modal.hide('edit-modal')
        })
        .catch(() => { this.$refs.submit.preload = false })
    },
    onShowEditModal(id) {
      this.client_to_update = id
      this.medical_checkup_copy = null
      this.$v.$reset()
      this.$modal.show('edit-modal')
    },
    onDownloadFile(data) {
      axios.get(data.medical_checkup_copy.file, { responseType: 'blob' })
        .then(response => {
          const url = URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          const extension = data.medical_checkup_copy.file_name.split('.').pop()
          link.href = url
          link.setAttribute('download', `Medical check-up ${data.client.full_name} - ${data.client.group.name}.${extension}`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
        })
    },
  }
}
</script>
